var React = require('react');

function IcnLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("path",{"d":"M10.667 16.533h11.733v4.8h-11.733v-4.8zM18.667 8.213v2.987h2.987l-2.987-2.987zM22.4 15.467v-3.2h-4.8v-4.8h-6.933v8h11.733zM29.867 16c0-0.005 0-0.011 0-0.016 0-7.658-6.208-13.867-13.867-13.867-3.833 0-7.303 1.555-9.813 4.069l-0 0c-2.511 2.511-4.065 5.981-4.065 9.813 0 7.665 6.213 13.878 13.878 13.878 3.832 0 7.302-1.553 9.813-4.065v0c2.504-2.492 4.053-5.942 4.053-9.753 0-0.021-0-0.042-0-0.064v0.003zM23.467 25.067h-13.867v-18.667h8.747l5.12 5.12zM10.667 22.4h11.733v1.6h-11.733v-1.6zM30.88 17.067c-0.553 7.396-6.417 13.26-13.764 13.81l-0.050 0.003v1.067c7.983-0.558 14.322-6.897 14.877-14.83l0.003-0.050zM17.067 1.12c7.396 0.553 13.26 6.417 13.81 13.764l0.003 0.050h1.067c-0.558-7.983-6.897-14.322-14.83-14.877l-0.050-0.003zM1.12 14.933c0.553-7.396 6.417-13.26 13.764-13.81l0.050-0.003v-1.067c-7.983 0.558-14.322 6.897-14.877 14.83l-0.003 0.050zM14.933 30.88c-7.396-0.553-13.26-6.417-13.81-13.764l-0.003-0.050h-1.067c0.558 7.983 6.897 14.322 14.83 14.877l0.050 0.003z","key":1})]);
}

IcnLogo.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = IcnLogo;

IcnLogo.default = IcnLogo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/images/icn-logo.svg
// module id = 475
// module chunks = 0